;(function(window, $) {
  $(function() {
    $('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    });
  });
})(window, jQuery);
